
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/great-question",
      function () {
        return require("private-next-pages/destinations/great-question.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/great-question"])
      });
    }
  